// This file contains production-specific environment configuration.
// Used when building for production environment with maximum optimization.

export const environment = {
  environment: 'production',
  production: true,
  apiUrl: 'https://api.craftly.freemankpo.com',
  
  // Google OAuth Configuration
  googleAuth: {
    clientId: '1090947279024-bomgd95mld9g08lncac59bnjou1tp99n.apps.googleusercontent.com',
    redirectUri: 'https://craftly.freemankpo.com'
  },

  // Sentry Configuration
  sentry: {
    dsn: 'https://21aa2b6dd04c8b1c9a00957b658ed5d4@o4509971800981504.ingest.us.sentry.io/4509971937558528',
    enabled: true
  }
};